// extracted by mini-css-extract-plugin
export default {"mainContainer":"News_mainContainer__debts","imageContainer":"News_imageContainer__uhMlP","content":"News_content__Jlpl9"};